import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import ConfirmDialog from '../../common/ConfirmDialog/ConfirmDialog';
import { useStore } from '../../../store/index';
import { JOB_POSTING_STATUS } from '../../../utils/constants';
import { JobPostingContext } from '../../../contexts/JobPostingContext';

const CancelJobPostingDialog = ({ jobPostingPage }) => {
  const {
    jobPostingStore: {
      pendingCancellationJobPostingId,
      toggleCancelJobPostingModal,
      updateJobPostingStatus: updateJobPostingStatusStore
    }
  } = useStore();

  const {
    updateJobPostingStatus
  } = useContext(JobPostingContext);

  return (
    <ConfirmDialog
      headerText="Cancel Posting"
      open={!!pendingCancellationJobPostingId}
      onConfirm={() => {
        if (jobPostingPage) {
          updateJobPostingStatus(pendingCancellationJobPostingId, JOB_POSTING_STATUS.CANCELLED, jobPostingPage, toggleCancelJobPostingModal);
        } else {
          updateJobPostingStatusStore(pendingCancellationJobPostingId, JOB_POSTING_STATUS.CANCELLED, false, toggleCancelJobPostingModal);
        }
      }}
      onClose={() => {
        toggleCancelJobPostingModal();
      }}
      confirmText="Cancel Posting"
      cancelText="Cancel"
      positionedCloseButton
      confirmTestId="confirm-cancel-job-posting"
    >
      When you cancel your posting, you change the posting back into a draft.<br />
      Candidates will no longer be able to see the job posting or apply.<br />
      You will still be able to see any candidates who applied, your recommended candidates and your job posting details.<br />
      You can always re-publish your posting if you want to change it back to active later.
    </ConfirmDialog>
  );
};

export default observer(CancelJobPostingDialog);
